export default "__VITE_ASSET__BwdY6qTd__"